<body class="body-form-signin login-bg"
  [style]="whitelabel ? 'background-image: url(' + whitelabelURL + whitelabel + '/login.webp);' : ''">

  <main class="form-signin" [style]="whitelabel ? 'max-width: 400px' : ''">
    <app-message [service]="messageService"></app-message>
    <form class="form-shadow container g-0" [formGroup]="formService.form" autocomplete="off" novalidate (ngSubmit)="loginUser(formService.form.value)">
      <div class="row p-0 m-0 g-0">
        <div *ngIf="!whitelabel" class="col-12 col-sm-5 col-md-6 min-height poster">
          <div>
            <a href="https://cubos.com" target="_blank"><img class="p-3" src="assets/cubos_logo_k.svg" alt="CUBOS" width="80%"></a><br />
            Gewerbliche <strong>Ladeinfrastruktur</strong><br />und <strong>Photovoltaik-Anlagen</strong>
          </div>
        </div>

        <div class="p-4"
          [class]="whitelabel ? '' : 'col-12 col-sm-7 col-md-6'">
          <div class="text-center">
            <a href="https://cubos.com" target="_blank" *ngIf="!whitelabel">
              <img class="my-4" src="assets/images/cubos_connect_logo_4c.svg" alt="CUBOS.Connect" width="272">
            </a>
            <a *ngIf="whitelabel">
              <img class="logo mb-4" [src]="whitelabelURL + whitelabel + '/logo.png'" [alt]="whitelabel">
            </a>
          </div>
          <div *ngIf="_message!=''" class="alert alert-warning my-2">{{_message}}</div>
          <div class="form-floating mb-3">
            <input type="email" class="form-control" id="username" formControlName="username" placeholder="E-Mail" i18n-placeholder="@@EmailPlaceholder">
            <label for="username" i18n="@@E-MailLoginLabel">E-Mail</label>
            <div class="error">
              <em *ngIf="formService.validateControl('username') && formService.hasError('username', 'required')" i18n="@@UserRequired">E-Mail-Adresse wird benötigt</em>
            </div>
          </div>

          <div class="form-floating mb-3">
            <input type="password" class="form-control" id="password" formControlName="password" placeholder="Passwort" i18n-placeholder="@@PasswordPlaceholder">
            <label for="password" i18n="@@Password">Passwort</label>
            <div class="error">
              <em *ngIf="formService.validateControl('password') && formService.hasError('password', 'required')" i18n="@@PasswordRequired">Passwort wird benötigt</em>
            </div>
          </div>

          <div class="text-center">
            <button type="submit" class="w-100 btn btn-yellow" id="login" [disabled]="!formService.form.valid" i18n="@@LoginButton">Anmelden</button>

            <div class="row pt-2">
              <!--<div class="col-md-6">
                <a style="text-decoration: none;" class="text-dark small" id="register" [routerLink]="['/auth/register']" i18n="@@RegisterLink">
                  Noch nicht registriert?
                </a>
              </div>-->
              <div class="col-12">
                <a style="text-decoration: none;" class="text-dark small" id="forgetpassword" [routerLink]="['/auth/forgotpassword']" i18n="@@ForgotPasswordLink">
                  Passwort vergessen?
                </a>
              </div>
              <div class="col-12 text-center">
                <p class="mt-2 mb-3 text-muted">
                  <a href="https://www.cubos.com" target="_blank" id="cuboshomepage" class="text-dark small" style="text-decoration: none;">
                    © {{currentYearLong()}} <strong>CUBOS</strong>&nbsp;Service GmbH
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>

      
    </form>

  </main>
</body>

<!--<ngx-spinner [fullScreen]="true"></ngx-spinner>-->
